<template>
  <div class="newInviteFriends">
    <van-sticky v-if="showBar==1">
      <van-nav-bar
        :border="false"
        :safe-area-inset-top="true"
        title="分享赚邀工币"
        left-arrow
        @click-left="onClickLeft"
      />
    </van-sticky>

    <div class="huodong-div">
      <div class="huodong-img">

        <div class="qr-code">
          <img :src="img" style="">
        </div>

        <div class="bottom-img">
          <img :src="btnImg" class="btn_fab" @click="onScreenshot">
          <img :src="share_btn_share" class="btn_fab" @click="toShare">
        </div>

        <div class="hist-list">
          <div class="hist-div">
            <div class="hist-content">

              <div class="share-title-div">
                <img :src="share_title_yaoqing" class="share_title_yaoqing">
              </div>

              <div class="hist-title">

                <van-col span="8" class="nums">
                  <div><van-icon :name="share_icon_person"/>
                  直接邀请 </div>
                  <div><span>{{ totalRows }}人</span></div>
                </van-col>

                <van-col span="8" class="nums">
                  <div><van-icon :name="share_icon_jianjie"/>
                  间接邀请 </div>
                  <div><span>{{ numInfo.indirectNum }}人</span></div>
                </van-col>

                <van-col span="8" class="nums">
                  <div><van-icon :name="share_icon_yaogongbi"/>
                  累计收入 </div>
                  <div><span>{{ numInfo.sumCoin }}邀工币</span></div>
                </van-col>

              </div>
              <div v-if="list.length === 0 && !incomeListLoading" class="noContent">
                <div class="blank-tip-title">暂未邀请好友</div>
                <div class="blank-tip-info">{{ info }}</div>
              </div>

              <div v-else class="list-content" @scroll="handleScroll($event)">
                <van-list
                  v-model="incomeListLoading"
                  :finished="listLoadFinished"
                  @load="onLoad"
                >

                  <div class="coins-list">
                    <van-cell-group>
                      <div class="van-cell coins-list-cell" v-for="(item, index) in list" :key="index">
                        <div class="van-cell__title">
                          <span class="title">{{ item.operate }}</span>
                          <div class="van-cell__label">{{ item.createTime }}</div>
                        </div>
                        <div class="van-cell__value">
                          <!--                        <van-icon name="plus">{{ item.coin }}</van-icon>-->
                          <div class="van-cell-coin">
                            <van-icon :name="share_icon_yaogongbi"/>
                            <span style="color:#FFB111FF;"> +{{ item.coin }}</span>
                          </div>
                          <div class="van-cell-user">
                            <span> 邀请{{ item.userCount }}人</span>
<!--                            <van-icon :name="contacts_icon_arrow_down"/>-->
                            <van-icon v-if="item.userCount > 0" :name="contacts_icon_arrow_down" @click="inviteList(item.mobile)"/>
                          </div>
                        </div>
                        <span class="icon_invalid" v-show="item.expire === 1"></span>
                      </div>
                    </van-cell-group>
                  </div>
                </van-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-overlay :show="shareShow" @click="shareShow = false" z-index="999">
      <div class="share-popup" @click.stop>
        <van-icon color="#d3d3d3" style="float: right" name="close" @click="shareShow=false"/>
        <div class="share-popup-content">
          <div class="share-title">
            每邀请一位工友点击使用邀工网，即可获得5个邀工币
          </div>
          <div class="share-tip" style="text-align: center;color: #999999FF">
            分享到
          </div>
          <div class="share-icon" style="text-align: center">
            <van-row>
              <van-col span="8" @click="toWechat">
                <img src="../../assets/images/coins/share_icon_wechat.png">
                <div class="text">微信</div>
              </van-col>
              <van-col span="8" @click="toPengyouquan">
                <img src="../../assets/images/coins/share_icon_pengyouquan.png">
                <div class="text">朋友圈</div>
              </van-col>
              <van-col span="8" @click="toMianduimian">
                <img src="../../assets/images/coins/share_icon_mianduimian.png">
                <div class="text">我的推广码</div>
              </van-col>
            </van-row>
          </div>
          <div class="share-tip" style="text-align: center">
            <a @click="toInvitationRule">
              <van-icon name="question-o"/>
              邀请好友规则
            </a>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getCoinSumByRecommend, getCoinListByRecommend, getCryptoPhone } from '@api/activity'
import { getWxXcxQrCode } from '@api/home'
import { getPhone } from '@api/coins'

import share_title_yaoqing from '../../assets/images/coins/invite/share_title_yaoqing.png'
import share_btn_share from '../../assets/images/coins/invite/share_btn_share@2x.png'
import share_icon_download from '../../assets/images/coins/invite/share_icon_download@2x.png'
import share_icon_person from '../../assets/images/coins/invite/share_icon_person@2x.png'
import share_icon_yaogongbi from '../../assets/images/coins/invite/share_icon_yaogongbi@2x.png'
import share_icon_jianjie from '../../assets/images/coins/invite/share_icon_jianjie@2x.png'
import contacts_icon_arrow_down from '../../assets/images/coins/invite/contacts_icon_arrow_down@2x.png'

import bgImg from '../../assets/images/coins/invite_bg.png'
import topImg from '../../assets/images/coins/share_img_top@2x.png'
import CryptoJS from 'crypto-js'

export default {
  name: 'newInviteFriends',
  data () {
    return {
      showBar: false,
      share_title_yaoqing: share_title_yaoqing,
      share_btn_share: share_btn_share,
      btnImg: share_icon_download,
      share_icon_person: share_icon_person,
      share_icon_yaogongbi: share_icon_yaogongbi,
      share_icon_jianjie: share_icon_jianjie,
      contacts_icon_arrow_down: contacts_icon_arrow_down,

      bgImg: bgImg,
      topImg: topImg,
      // btnImg: btnImg,

      numInfo:{},
      totalRows: 0,

      pageSize: 10,
      pageNum: 0,
      incomeListLoading: false,
      listLoadFinished: false,
      list: [],
      shareShow: false,
      info: '',
      img: '',
      cryptoPhone: ''
    }
  },

  created () {

    this.showBar = this.$route.query.showBar

    this.onLoad()

    this.getPhone()

    this.getCryptoPhone()
  },

  mounted () {

    // 获取累计收入
    getCoinSumByRecommend().then(res => {
      if (res.data.code === 200) {
        this.numInfo = res.data.data
        if (res.data.data.inviteNum == 0) {
          this.info = res.data.msg
        }
      } else {
        this.$toastMsg(res.data.msg)
      }
    })

    // this.refereesPhone = this.$route.query.refereesPhone
  },

  methods: {

    // 获取用户加密手机号（用于分享）
    getCryptoPhone () {
      getCryptoPhone().then(res => {
        if (res.data.code === 200) {
          this.cryptoPhone = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取页面滚动距离
    handleScroll (e) {
      let el = e.target

      //判断是否到达div容器底部
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        // this.$toastMsg('滚动')
        //调用后台接口
        this.onLoad()
      }
    },

    onClickLeft () {
      // 返回上个页面
      this.$bridge.callHandler('back', response => {
        console.log('response:', response)
      })
    },

    // 获取手机号
    getPhone () {
      getPhone().then(res => {
        if (res.data.code === 200) {
          const key = 'abcdefghi1234567'
          const keyHex = CryptoJS.enc.Utf8.parse(key)

          // 加密
          let message = res.data.data
          let encrypt = CryptoJS.DES.encrypt(message, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          })

          this.refereesPhone = new Buffer(encrypt.toString()).toString('base64')

          this.creatQrCode()
        } else {
          this.$toastMsg(res.data.msg)
        }
      })

    },

    // 分享
    toShare () {
      this.shareShow = true
    },

    // 获取历史记录
    onLoad () {
      this.pageNum++
      this.incomeListLoading = true
      getCoinListByRecommend({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.list = this.list.concat(res.data.data.rows)
          }
          this.totalRows = res.data.data.totalRows
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 分享微信
    toWechat () {
      // alert('分享微信')
      const data = {
        title: '邀请下载',
        content: '邀请您和我一起使用邀工网，发活、找活一键触达',
        type: 0,//0-微信；1-朋友圈
        path: '/pages/getJob/index?cryptoMobile=' + this.cryptoPhone,//小程序地址
        url: '/coinsInvitation',
      }
      this.$bridge.callHandler('inviteFriend', data, response => {
        console.log('response:', response)
      })
    },

    // 分享朋友圈
    toPengyouquan () {
      // alert('分享朋友圈')
      const data = {
        title: '邀请您和我一起使用邀工网，发活、找活一键触达',
        content: '邀请您和我一起使用邀工网，发活、找活一键触达',
        type: 1,//0-微信；1-朋友圈
        path: 'pages/getJob/index?cryptoMobile=' + this.cryptoPhone,//小程序地址
        url: '/coinsInvitation',
      }
      this.$bridge.callHandler('inviteFriend', data, response => {
        console.log('response:', response)
      })
    },

    // 面对面分享
    toMianduimian () {
      // this.enterRouter('coinsInvitation')
      const data = {
        title: '邀工网',
        url: `${process.env.VUE_APP_BASE_HOST}/coinsInvitation`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 跳转邀请好友规则
    toInvitationRule () {
      const data = {
        title: '邀请好友规则',
        url: `${process.env.VUE_APP_BASE_HOST}/staticPages/invitationRule`
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },

    // 下载图片
    onScreenshot () {
      // 滚动到顶部（关闭筛选弹窗后可能不会回到顶部）
      window.scrollTo({
        'top': 0,
        'behavior': 'smooth'
      })

      let that = this
      setTimeout(function () {
        that.$bridge.callHandler('screenshot', response => {
          console.log('response:', response)
        })
      }, 500)
    },

    // 生成二维码
    creatQrCode () {
      getWxXcxQrCode().then(res => {
        if (res.data.code === 200) {
          this.img = 'data:image/png;base64,' + res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    inviteList (mobile) {
      const data = {
        title: '邀请好友',
        url: `${process.env.VUE_APP_BASE_HOST}/inviteList?showBar=`+this.showBar+`&mobile=` + mobile
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      });
    }
  }
}
</script>

<style scoped lang="less">

.newInviteFriends {
  min-height: 100%;
  background-color: #fe7653;

  .add-num {
    vertical-align: 7%;
  }

  .van-nav-bar {
    background-color: #FD3043;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-icon {
    color: #FFFFFF !important;;
  }

  //noinspection CssInvalidPseudoSelector
  ::v-deep .van-nav-bar__title {
    color: #FFFFFF !important;
  }
}

.bg-img {
  width: 100%;
  height: 100%;
}

.huodong-div {
  background: linear-gradient(1deg, #fe7653 0%, #FD3043 100%);
  height: 500px;
  width: 100%;
}

.huodong-img {
  //padding-top: constant(safe-area-inset-top);
  //padding-top: env(safe-area-inset-top);
  width: 100%;
  height: 437px;
  background-size: contain;
  background-image: url('../../assets/images/coins/share_img_top@2x.png');
  text-align: center;
  position: absolute;
  float: right;
  //top: 0;
}

.qr-code {
  margin: 140px auto 0;
  width: 100%;
  text-align: center;

  img {
    border-radius: 3px;
    border: 2px solid #FACE78;
    background-color: #FFFFFF;
    padding: 3px;
    margin: auto;
    text-align: center;
    height: 155px;
    width: 155px;
  }
}

.bottom-img {
  padding: 35px 30px;
  display: flex;
  width: 100%;
}

.btn_fab {
  height: 85px;
  padding-top: 15px;
  padding-bottom: 10px;
  width: 50%;
}

.hist-list {
  margin-top: 10px;
  background-color: #fe7653;
  padding-bottom: 30px;

  .hist-div {
    margin: 0 12px 20px 12px;
    padding: 12px 12px 6px 12px;
    background: #FEF0DFFF;
    border-radius: 8px;
    opacity: 1;
  }
}

.hist-content {
  min-height: 216px;
  width: 100%;
  position: relative;

  .share_title_yaoqing {
    margin-top: -26px;
    margin-left: 100px;
    width: 120px;
    position: absolute;
  }

  .hist-title {
    text-align: left;
    width: 100%;
    line-height: 25px;
    height: 25px;
    opacity: 1;
    font-size: 14px;
    font-weight: bold;
    .nums{
      text-align: center;
      padding: 10px 0;
    }
    .van-icon {
      font-size: 20px;
      vertical-align: -20%;
    }

    span {
      font-size: 13px;
      color: #FFB111FF;
    }
  }
}

.blank-tip-title {
  padding: 19px 0;
  font-size: 20px;
}

.blank-tip-info {
  color: #666666FF;
  padding: 0 50px;
  font-size: 16px;
}

.list-content {
  width: 100%;
  text-align: left;
  max-height: 400px;
  overflow: auto;
  white-space: nowrap;

  .van-cell-group {
    background-color: #FEF0DFFF;
  }
}

.van-cell {
  padding: 8px 8px 8px 12px;
  border-radius: 6px;
  margin-bottom: 10px;
  display: flex;
  height: 60px;
  justify-content: space-between;

  .title {
    font-size: 14px !important;
  }

  .van-cell__label {
    font-size: 13px !important;
  }

  .van-cell__value {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 0.3;
    text-align: right;

    //height: 30px;
    .van-cell-coin{
      font-size: 14px;
      padding-right: 4px;
      display: flex;
      justify-content: right;
      .van-icon {
        font-size: 20px;
      }
    }
    .van-cell-user{
      display: flex;
      font-size: 13px;
      line-height: 16px;
      justify-content: right;
      color: #333333;
      .van-icon {
        font-size: 16px;
      }
    }
  }
}

.van-cell:not(:last-child)::after {
  display: inline;
}

.share-popup {
  margin: 50% auto;
  background-size: contain;
  width: 300px;
  height: 375px;
  background-image: url('../../assets/images/coins/coins_share.png');

  .share-popup-content {
    padding: 10px 20px;
  }

  .share-title {
    font-size: 16px;
    padding-top: 130px;
  }

  .share-icon {
    padding-top: 20px;

    img {
      margin: auto;
      height: 50px;
      width: 50px;
    }

    .text {
      margin-top: 5px;
      font-size: 14px;
    }
  }

  .share-tip {
    font-size: 14px;
    padding-top: 20px;
  }

  .van-icon {
    vertical-align: -10%
  }
}

</style>
